import { getFeature } from 'Cloud/Application/FeaturesEs6';

/**
 * alpha-team
 * CLOUDWEB-17774: Качество. Очистка места. Добавить возможность выделять и удалять более тысячи писем/файлов
 */
export const seriallyClearQuotaCleanerFeature: boolean = getFeature('serially-clear-quota-cleaner');
